// Browser-local anonymous draft identifier.
//
// One UUID per browser profile, persisted under a versioned localStorage
// key.  Never contains customer identity information.  Rotated only:
//   * after a successful claim_planner_draft (server draft becomes
//     authenticated, so the anonymous slot for this browser is done);
//   * on demand via rotateAnonymousDraftId().
// Not rotated on normal wizard navigation, on refresh, or on sign-out.

const KEY = 'etff.anonymous_draft_id.v1';

function isBrowser() {
  return typeof window !== 'undefined' && !!window.localStorage;
}

function makeUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback: RFC4122 v4 via getRandomValues.
  const buf = new Uint8Array(16);
  (crypto || {}).getRandomValues?.(buf) ??
    (function () {
      for (let i = 0; i < 16; i++) buf[i] = Math.floor(Math.random() * 256);
    })();
  buf[6] = (buf[6] & 0x0f) | 0x40;
  buf[8] = (buf[8] & 0x3f) | 0x80;
  const hex = [...buf].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function getOrCreateAnonymousDraftId() {
  if (!isBrowser()) return null;
  try {
    let id = window.localStorage.getItem(KEY);
    if (id && /^[0-9a-f-]{36}$/i.test(id)) return id;
    id = makeUuid();
    window.localStorage.setItem(KEY, id);
    return id;
  } catch {
    return null;
  }
}

export function peekAnonymousDraftId() {
  if (!isBrowser()) return null;
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearAnonymousDraftId() {
  if (!isBrowser()) return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function rotateAnonymousDraftId() {
  clearAnonymousDraftId();
  return getOrCreateAnonymousDraftId();
}
